// extracted by mini-css-extract-plugin
export default {"invite_table":"InviteTable_invite_table__ntQTn"};